import React from "react";
import { Fade } from "react-reveal";
import { useTranslation } from 'react-i18next';
import PrivacyPolicyES from "./PrivacyPolicyEs";

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  const userLanguage = navigator.language || navigator.userLanguage;
  const mainLanguage = userLanguage.split('-')[0];
  console.log(mainLanguage);
  


  return (
    <section id="privacy" style={{backgroundColor: "#FFFFFF"}}>
      <Fade duration={1000}>
      <div>
        {mainLanguage === 'es' ? 
          <PrivacyPolicyES /> :
          <iframe
            src="https://www.privacypolicies.com/live/ec077355-5ecb-40ee-aec0-07e65949767c"
            title="Privacy policy"
            width="100%"
            height="1000em"
        />
        }
    </div>
      </Fade>
    </section>
  );
};

export default PrivacyPolicy;
